import { PresentationRole, TreeViewTableItem } from "@/apis/preview/v2/types";

type TableItems = {
  key: string;
  value: string;
  isStandard?: boolean;
}[];

const StructureTable = ({
  table,
  preRole,
}: {
  table: TreeViewTableItem;
  preRole?: PresentationRole;
}) => {
  const data: TableItems = [
    {
      key: "주석 목차",
      value: preRole ? `[${preRole.key}] ${preRole.label}` : "",
      isStandard: preRole ? !preRole.isExtended : undefined,
    },
    {
      key: "표 이름(한글)",
      value: table.axis.find((t) => t.tagType === "TABLE")?.tagKoLabel || "",
      isStandard: !table.isExtended,
    },
    {
      key: "표 이름(영문)",
      value: table.axis.find((t) => t.tagType === "TABLE")?.tagEnLabel || "",
      isStandard: !table.isExtended,
    },
  ];
  return (
    <div className="self-stretch rounded-sm border border-neutral-300 w-full overflow-hidden">
      <table className="w-full table-fixed">
        <colgroup>
          <col className="w-[240px]" />
          <col />
        </colgroup>
        <tbody>
          {data.map((item) => (
            <tr key={item.key} className="border-b border-neutral-200">
              <th
                scope="row"
                className="bg-neutral-50 min-w-[80px] px-3 py-2 text-center align-middle"
              >
                <span className="text-primary body-1-normal-medium">
                  {item.key}
                </span>
              </th>
              <td className="bg-white min-w-[80px] px-3 py-2 align-middle">
                <div className="flex items-center gap-1 min-w-0">
                  {item.isStandard !== undefined &&
                    (item.isStandard ? (
                      <div className="flex px-1 py-0.5 justify-center items-center gap-2.5 rounded-sm bg-neutral-950">
                        <span className="text-white whitespace-nowrap text-center caption-1-medium">
                          표준
                        </span>
                      </div>
                    ) : (
                      <div className="flex px-1 py-0.5 justify-center items-center gap-2.5 rounded-sm bg-purple-100">
                        <span className="text-purple-600 whitespace-nowrap text-center caption-1-medium">
                          확장
                        </span>
                      </div>
                    ))}
                  <span className="text-primary body-1-normal-medium truncate block w-full">
                    {item.value}
                  </span>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default StructureTable;
